const onLoadImageHandler = (event) => {
  if (event.target.naturalHeight == 1) {// baker and taylor null image
    event.target.src = '/fallback.png';
    //console.log(event);
    //event.target.parentElement.style.display = "none";
  }
};

export default onLoadImageHandler;